import { makeVar, ReactiveVar } from '@apollo/client';
import { ConnectorFragment } from '@/graphql/generated/graphql';
import { produce } from 'immer';

export interface ICurrentConnector {
  data: ConnectorFragment;
  isConnectorModalOpen: boolean;
}

export const currentConnectorInitialState: ICurrentConnector = {
  isConnectorModalOpen: false,
  data: {
    id: '',
    name: '',
    parameters: [],
    tokenExpired: false,
    archived: false,
  },
};

export const currentConnectorVar: ReactiveVar<ICurrentConnector> =
  makeVar<ICurrentConnector>(currentConnectorInitialState);

export const setConnectorData = (connectorData: Partial<ConnectorFragment>) => {
  currentConnectorVar(
    produce(currentConnectorVar(), (draft) => {
      draft.data = {
        ...draft.data,
        ...connectorData,
      };
    })
  );
};
